import React from 'react'
import { Col, Collapse, Row, Tabs, Icon } from "antd";
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import Button from "../../../components/Buttons";
import helper from "../../../helper/helper";

// Components
import Container from "../../../containers/Container";
import Api_tnn from "../../../api/api.tnn";
import Message from "../../../components/Messages";
import constants from "../../../constants/constant"
import Select from "../../../components/Common/Select"
import typo, { MESSAGE } from '../../../constants/dictionaries'
import { Legend, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, LineChart, Line, } from 'recharts'
const { TabPane } = Tabs;
const compare = (a, b) => {
    if (a.id < b.id) {
        return 1;
    }
    if (a.id > b.id) {
        return -1;
    }
    return 0;
}
class BieuDo extends React.Component {
    constructor(props) {
        super(props);
        const { functions } = props;
        this.state = {
            data: [],
            data_cot: [],
            data_tram: [],
            data_bieudo: [],
            data_doituong: [],
            data_thongso: [],
            doiTuongQT: 0,
            thongsoQT: [],
            name_thongso: {
                thongso_1: "",
                thongso_2: ""
            }
        }
    }

    componentDidMount() {
        const { idTramQT } = this.props
        this.GetTPMT_Exist()
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const { idGiayPhep } = this.props;
        if (prevProps.idGiayPhep !== idGiayPhep) {
            this.setState({
                thongsoQT: [],
                data_bieudo: [],
                data: []
            })
            this.GetTPMT_Exist()
        }
    }
    downloadFilePdf = () => {
        const input = document.getElementById('cot');
        helper.exportPdf(input, 'landscape', "BieuDo.pdf")
      }
      downloadFilePdf1 = () => {
        const input = document.getElementById('thoigian');
        helper.exportPdf(input, 'landscape', "BieuDo.pdf")
      }

    GetBieuDo_SoLanVuotNguong = (doiTuongQT) => {
        const { idGiayPhep, idTramQT } = this.props;
        new Api_tnn().GetBieuDo_SoLanVuotNguong({ token: this.props.user.access_token, id_giayphep: idGiayPhep, doituongqt: doiTuongQT, id_tramqt: idTramQT })
            .then(res => {
                this.GetThongSos_Exist(doiTuongQT, res)
                this.setState({
                    data_bieudo: res,
                })
            })
            .catch(err => {
                Message.error(err.message)
            })
    };

    GetTPMT_Exist = () => {
        const { idGiayPhep, idTramQT } = this.props;
        new Api_tnn().GetTPMT_Exist({ token: this.props.user.access_token, id_giayphep: idGiayPhep, id_tramqt: idTramQT })
            .then(res => {
                let data_doituong = []
                res.length > 0 && res.map((vl, idx) => {
                    let doituong = constants.DOI_TUONG_QUAN_TRAC.filter(x => x.id === vl)
                    data_doituong.push(doituong[0])
                })
                this.setState({
                    data_doituong: data_doituong.sort(compare),
                    doiTuongQT: data_doituong.length > 0 ? data_doituong.sort(compare)[0].id : 0
                })
                data_doituong.length > 0 && this.GetBieuDo_SoLanVuotNguong(data_doituong.sort(compare)[0].id)

            })
            .catch(err => {
                Message.error(err.message)
            })
    };

    GetThongSos_Exist = (doiTuongQT, data_vuotnguong) => {
        const { idGiayPhep, idTramQT } = this.props;
        new Api_tnn().GetThongSos_Exist({ token: this.props.user.access_token, id_giayphep: idGiayPhep, doituongqt: doiTuongQT, id_tramqt: idTramQT })
            .then(res => {
                if (data_vuotnguong && data_vuotnguong.length > 0) {
                    let thongso = res.filter(x => x.tenThongSo.toUpperCase().trim() === data_vuotnguong[0].name.toUpperCase().trim())
                    if (thongso && thongso.length > 0) {
                        this.setState({ thongsoQT: [thongso[0].idThongSo] })
                        this.GetBieuDo_ThongSos_GiaTris_Timeline(thongso[0].idThongSo)
                    }
                } else {
                    if (res && res.length > 0) {
                        this.setState({ thongsoQT: [res[0].idThongSo] })
                        this.GetBieuDo_ThongSos_GiaTris_Timeline(res[0].idThongSo)
                    }
                }
                this.setState({
                    data_thongso: res.map((vl, idx) => ({ ...vl, tenHienThi: vl.tenThongSo + " (" + vl.tenDonVi + ")" })),
                })
            })
            .catch(err => {
                Message.error(err.message)
            })
    };

    GetBieuDo_ThongSos_GiaTris_Timeline = (idThongSo, idThongSo2) => {
        const { idGiayPhep, idTramQT } = this.props;
        const { doiTuongQT } = this.state
        new Api_tnn().GetBieuDo_ThongSos_GiaTris_Timeline({
            token: this.props.user.access_token,
            idThongSo: idThongSo,
            idThongSo2: idThongSo2,
            idGiayPhep: idGiayPhep,
            id_TramQT: idTramQT,
            doiTuongQT: doiTuongQT
        })
            .then(res => {
                this.setState({ data: res })
            })
            .catch(err => {
                Message.error(err.message)
            })
    };

    selectThongsoQT = (value, item) => {
        if (value.length === 1) {
            this.GetBieuDo_ThongSos_GiaTris_Timeline(value[0])
            this.setState({ thongsoQT: value })
        } else if (value.length === 2) {
            this.setState({
                thongsoQT: value,
                name_thongso: {
                    thongso_1: item[0].props.children,
                    thongso_2: item[1].props.children
                }
            })
            this.GetBieuDo_ThongSos_GiaTris_Timeline(value[0], value[1])
        } else if (value.length > 2) {
            Message.warning(MESSAGE.CSCORE_GIOI_HAN_THONG_SO)
        } else {
            this.setState({ thongsoQT: value })
        }
    }

    onChangeTabs = (id) => {
        this.setState({
            doiTuongQT: Number(id),
            thongsoQT: [],
            data_bieudo: [],
            data: []
        })
        this.GetBieuDo_SoLanVuotNguong(Number(id))
    }

    onClickBar = (item, value) => {
        const { data_thongso } = this.state
        let thongso = data_thongso.filter(x => x.tenThongSo.toUpperCase().trim() === item.name.toUpperCase().trim())
        if (thongso && thongso.length > 0) {
            this.setState({
                thongsoQT: [thongso[0].idThongSo]
            })
            this.GetBieuDo_ThongSos_GiaTris_Timeline(thongso[0].idThongSo)
        }
    }
    CustomizedAxisTick = (item) => {
        return (
            <g transform={`translate(${item.x},${item.y})`}>
                <text x={0} y={0} dy={16} textAnchor="end" fill="#666" transform="rotate(-35)">{item.payload.value}</text>
            </g>
        );
    };

    render() {
        const { data_doituong, name_thongso, data_bieudo, thongsoQT, data_thongso, data } = this.state
        const COLORS = ['#faad14', '#f5222d', '#52c41a'];

        return (
            <Container>
                <Tabs tabPosition='left' onChange={this.onChangeTabs}>
                    {data_doituong.map((vl, idx) => <TabPane tab={vl.ten} key={vl.id}>
                        <Row type="flex" justify="start" gutter={[24, 24]} style={{ marginBottom: 20 }}>
                            {data_thongso.length > 0 &&
                                <Col>
                                    <Select
                                        modeSelect="multiple"
                                        placeholder={typo.cscore_thongSoQuanTrac}
                                        onChange={(value, name) => this.selectThongsoQT(value, name)}
                                        dataSource={data_thongso}
                                        width="350px"
                                        name="tenHienThi"
                                        name_value="idThongSo"
                                        mandatory={false}
                                        value={thongsoQT}
                                    />
                                </Col>}
                        </Row>

                        <Row type="flex" justify="start" gutter={[24, 24]}>
                            <Col md={24} lg={12} className="char-center" style={{ height: "421px", marginBottom: 30 }}>
                                {data_bieudo.length > 0 ?
                                    <div style={{ width: "100%" }}>
                                        <ResponsiveContainer height={400} width="90%" id="cot"> 
                                            <BarChart data={data_bieudo} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
                                                <CartesianGrid strokeDasharray="3 3" />
                                                <XAxis dataKey="name" />
                                                <YAxis />
                                                <Tooltip />
                                                <Legend />
                                                <Bar dataKey="value" fill="#faad14" name="Số lần vượt ngưỡng" maxBarSize={50} label onClick={this.onClickBar} />
                                            </BarChart>
                                        </ResponsiveContainer>
                                        <div style={{ textAlign: "center", fontWeight: "bold" }}>Biểu đồ thống kê số lần vượt ngưỡng </div>
                                    </div>
                                    : <div style={{ color: "#cfcdcd", textAlign: "center" }}>Không có dữ liệu</div>}
                            </Col>

                            <Col md={24} lg={12} className="char-center" style={{ height: "421px", marginBottom: 30 }}>
                                {data.length > 0 && thongsoQT && thongsoQT.length === 1 &&
                                    <div style={{ width: "100%" }}>
                                        <ResponsiveContainer height={400} width="90%" id="thoigian">
                                            <LineChart data={data}
                                                margin={{ top: 20, right: 30, left: 20, bottom: 10 }}>
                                                <CartesianGrid strokeDasharray="3 3" />
                                                <XAxis dataKey="name" height={90} tick={this.CustomizedAxisTick} padding={{ left: 30, right: 30 }} />
                                                <YAxis yAxisId="left" />
                                                {/* <YAxis yAxisId="right" orientation="right" /> */}
                                                <Tooltip />
                                                <Legend />
                                                <Line yAxisId="left" type="monotone" dataKey="max" name="Giới hạn trên" stroke="#f5222d" />
                                                <Line yAxisId="left" type="monotone" dataKey="min" name="Giới hạn dưới" stroke="#f5222d" />
                                                <Line yAxisId="left" type="monotone" dataKey="value" name="Giá trị đo" stroke="#82ca9d" />
                                            </LineChart>
                                        </ResponsiveContainer>
                                        <div style={{ textAlign: "center", fontWeight: "bold" }}>Biểu đồ giá trị đo theo thời gian </div>
                                    </div>}

                                {data.length > 0 && thongsoQT && thongsoQT.length === 2 &&
                                    <div style={{ width: "100%" }}>
                                        <ResponsiveContainer height={400} width="90%">
                                            <LineChart data={data}
                                                margin={{ top: 20, right: 30, left: 20, bottom: 10 }}>
                                                <CartesianGrid strokeDasharray="3 3" />
                                                <XAxis dataKey="name" height={90} tick={this.CustomizedAxisTick} padding={{ left: 30, right: 30 }} />
                                                <YAxis yAxisId="left" />
                                                <YAxis yAxisId="right" orientation="right" />
                                                <Tooltip />
                                                <Legend />
                                                <Line yAxisId="left" type="monotone" name={name_thongso.thongso_1} dataKey="_1" stroke="#8884d8" />
                                                <Line yAxisId="right" type="monotone" name={name_thongso.thongso_2} dataKey="_2" stroke="#82ca9d" />
                                            </LineChart>
                                        </ResponsiveContainer>
                                        <div style={{ textAlign: "center", fontWeight: "bold" }}>Biểu đồ giá trị đo theo thời gian </div>
                                    </div>}
                            </Col>
                        </Row>
                        <Row>
                            <Col span={12} style={{ textAlign: "end" }}>
                                <Button
                                    type="pdf"
                                    onClick={this.downloadFilePdf}
                                >
                                    <Icon type="file-excel" />
                                    {"Xuất file pdf"}
                                </Button>
                            </Col>
                            <Col span={12} style={{ textAlign: "end" }}>
                                <Button
                                    type="pdf"

                                    onClick={this.downloadFilePdf1}
                                >
                                    <Icon type="file-excel" />
                                    {"Xuất file pdf"}
                                </Button>

                            </Col>
                        </Row>
                        {data.length === 0 && data_bieudo.length === 0 && <div style={{ color: "#cfcdcd", textAlign: "center" }}>Không có dữ liệu</div>}
                    </TabPane>)}
                </Tabs>
            </Container>
        )
    }
}

BieuDo.propTypes = {
    idGiayPhep: PropTypes.string
};


const mapStateToProps = (state) => ({
    user: state.oidc.user
});

export default connect(mapStateToProps)(BieuDo)